<template>
    <v-card>
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <pie-chart :data="data" :download="true"/>
      </v-card-text>
    </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    data: Object,
  },
}
</script>

<style>

</style>
